import React, { useState, useEffect, useImperativeHandle, useCallback } from 'react';
import { apiHolder, apis, YUNXIN_NONE_SENTINEL } from 'api';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { showDialog } from '@web-common/utils/utils';
import CloseIcon from '@web-common/components/UI/Icons/svgs/CloseSvg';
import Contact from '../Contact/contact';
import ContactIMModal from '@web-common/components/UI/SiriusContact/IMModal';
import styles from './memberChooser.module.scss';
import { getMainAccount, transContactModel2ContactItem } from '@web-common/components/util/contact';
import lodashGet from 'lodash/get';
import { getIn18Text } from 'api';
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const MEMBER_LIMIT = 500;
export const ChosenMemberItem = props => {
    const { member, removeMember } = props;
    const { contact: { contactLabel, color, contactName }, } = member;
    return (React.createElement("div", { className: styles.chosenMemberItem },
        React.createElement("div", { className: styles.avatar, style: { background: color } }, contactName.slice(0, 1) || contactLabel),
        React.createElement("div", { className: styles.memberName }, contactName),
        React.createElement("div", { className: styles.removeBtn, onClick: () => removeMember && removeMember(member) },
            React.createElement(CloseIcon, null))));
};
const MemberChooser = React.forwardRef((props, ref) => {
    const { setChosenMembers, disabledMembers, wrapStyle, limit = MEMBER_LIMIT, limitTitle = getIn18Text('QUNZURENSHUCHAO'), limitContent = `群组人数上限为${limit}人`, } = props;
    const [members, setMembers] = useState([]);
    useImperativeHandle(ref, () => ({
        getChosenMembers: () => members,
    }));
    const curLimit = limit - ((disabledMembers === null || disabledMembers === void 0 ? void 0 : disabledMembers.length) || 0);
    const chooseMember = (member) => {
        let checked = false;
        const prevMembers = members.slice();
        const index = prevMembers.findIndex(value => value.contact.id === member.contact.id);
        let curMembers;
        if (index >= 0) {
            checked = false;
            prevMembers.splice(index, 1);
            curMembers = prevMembers;
        }
        else if (prevMembers.length >= curLimit) {
            checked = false;
            showDialog({ title: limitTitle, content: limitContent });
            curMembers = prevMembers;
        }
        else {
            checked = true;
            curMembers = [...prevMembers, member];
        }
        if (setChosenMembers) {
            setChosenMembers(curMembers);
        }
        setMembers(curMembers);
        return checked;
    };
    return (React.createElement("div", { className: styles.teamMemberBox, style: wrapStyle },
        React.createElement("div", { className: styles.searchMemberBox },
            React.createElement(Contact, { chooseMember: chooseMember, chosenMembers: members, disabledMembers: disabledMembers })),
        React.createElement("div", { className: styles.chosenMemberBox },
            React.createElement("div", { className: styles.chosenStatus },
                getIn18Text('YIXUAN\uFF1A'),
                members.length,
                "/",
                curLimit),
            React.createElement("div", { className: styles.memberList }, members.map(member => (React.createElement(ChosenMemberItem, { key: member.contact.id, member: member, removeMember: chooseMember })))))));
});
export const MemberChooserModal = props => {
    const { chosenMembers, account: _account, onOk, onCancel, visible, type = 'yunxin', title = getIn18Text('TIANJIACHENGYUAN') } = props;
    const account = _account || getMainAccount();
    const disableCheckList = chosenMembers.reduce((arr, item) => {
        if (item) {
            if ('contact' in item) {
                arr.push(transContactModel2ContactItem(item));
            }
            else {
                arr.push(item);
            }
        }
        return arr;
    }, []);
    const [addMemberVisible, setAddMemberVisible] = useState(false);
    const [chosenList, setChosenList] = useState([]);
    useEffect(() => {
        setAddMemberVisible(visible);
    }, [visible]);
    const addMember = useCallback(async () => {
        const queryIds = new Set(chosenList.map(item => {
            return item.id;
        }));
        if (!queryIds.size) {
            return;
        }
        const yunxinMap = await contactApi.batchEnsureYunxinByIds([...queryIds.values()], account);
        const fetchModel = [...yunxinMap.entries()]
            .filter(([, info]) => info.yxid && info.yxid !== YUNXIN_NONE_SENTINEL)
            .map(([contactId, info]) => ({
            contact: { id: contactId },
            contactInfo: [
                {
                    contactItemType: 'yunxin',
                    contactItemVal: info.yxid,
                    contactItemRefer: info.yxToken,
                },
            ],
        }));
        onOk && onOk(fetchModel);
    }, [chosenList.length, lodashGet(chosenList, '[0].id', '')]);
    return (React.createElement(Modal, { closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }), className: styles.chooserWrap, title: title, width: 600, wrapClassName: "im-change-owner", visible: addMemberVisible, onCancel: onCancel, onOk: addMember, getContainer: () => document.body },
        React.createElement(ContactIMModal, { disableCheckList: disableCheckList, accountRootKey: account, useEdm: false, excludeOrgTypes: [1, 2], onChange: data => {
                setChosenList(data);
            } })));
};
export default MemberChooser;
